/**
 * iter233 · Planning sheet column config + field-level edit rights.
 *
 * Mirrors the user's MASTER PP `PRODUCTION PLANING` sheet:
 *   DATE · DAY · SHIFT · LINE · SO NO · CUSTOMER · PRODUCT CODE · PARTY CODE ·
 *   DESCRIPTION · KG · PACK SIZE · BATCH SIZE · NO. OF BATCH · TOTAL · OUTPUT · REMARK
 * plus the live ERP columns (🔴 left · 🟢 made · 🔵 dispatched · RM · dispatch).
 */

// UI field → API field on factory_plans
export const API_FIELD = {
  total_planned: 'quantity',
  actual_output: 'completed_quantity',
};

const FH_ROLES = ['owner', 'admin'];
const FH_ONLY = ['batch_size', 'pack_size', 'product_code', 'party_code',
  'product_id', 'product_name'];
const MANAGER = ['planned_date', 'shift', 'line_no', 'quantity', 'batches',
  'priority', 'purpose', 'instructions', 'remarks', 'required_date',
  'completed_quantity', 'customer_id', 'customer_name', 'sales_order_id',
  'sales_order_number', 'production_manager_id', 'production_manager_name',
  'production_supervisor_id', 'production_supervisor_name'];
const SUPERVISOR = ['completed_quantity', 'remarks'];

export const canEditField = (role, uiField) => {
  const f = API_FIELD[uiField] || uiField;
  if (FH_ROLES.includes(role)) return FH_ONLY.includes(f) || MANAGER.includes(f);
  if (role === 'manager') return MANAGER.includes(f);
  return SUPERVISOR.includes(f);
};

export const canPlan = (role) => FH_ROLES.includes(role) || role === 'manager';
export const isFactoryHead = (role) => FH_ROLES.includes(role);

export const COLUMNS = [
  { k: 'shift',             l: 'Shift',        w: 78,  edit: 'shift' },
  { k: 'line_no',           l: 'Line',         w: 62,  edit: 'text',  ph: '1' },
  { k: 'product_code',      l: 'Prod Code',    w: 92,  edit: 'text' },
  { k: 'party_code',        l: 'Party',        w: 74,  edit: 'text' },
  { k: 'pack_size',         l: 'Pack Size',    w: 92,  edit: 'text',  ph: '25/BAG' },
  { k: 'sales_order_number', l: 'SO No.',      w: 96 },
  { k: 'required_quantity', l: 'Required kg',  w: 98,  align: 'right' },
  { k: 'batch_size',        l: 'Batch kg',     w: 84,  edit: 'num',   align: 'right' },
  { k: 'batches',           l: 'Batches',      w: 74,  edit: 'num',   align: 'right' },
  { k: 'total_planned',     l: 'Total kg',     w: 92,  edit: 'num',   align: 'right', strong: true },
  { k: 'actual_output',     l: 'Output kg',    w: 92,  edit: 'num',   align: 'right' },
  { k: 'variance',          l: 'Variance',     w: 92,  align: 'right' },
  { k: 'left_to_make',      l: '🔴 Left kg',   w: 92,  align: 'right', tone: 'red' },
  { k: 'available_made',    l: '🟢 Made kg',   w: 92,  align: 'right', tone: 'green' },
  { k: 'dispatched',        l: '🔵 Disp kg',   w: 92,  align: 'right', tone: 'blue' },
  { k: 'rm_status',         l: 'RM Status',    w: 108 },
  { k: 'priority',          l: 'Priority',     w: 84,  edit: 'priority' },
  { k: 'status',            l: 'Status',       w: 104 },
  { k: 'required_date',     l: 'Required',     w: 100, edit: 'date' },
  { k: 'dispatch_date',     l: 'Dispatch On',  w: 100 },
  { k: 'transporter',       l: 'Transporter',  w: 132 },
  { k: 'instructions',      l: 'Production Instruction', w: 210, edit: 'text', ph: 'e.g. make less salty' },
  { k: 'remarks',           l: 'Remarks',      w: 180, edit: 'text', ph: 'e.g. RM tomorrow' },
  { k: 'supervisor',        l: 'Supervisor',   w: 120 },
  { k: 'actions',           l: '',             w: 86 },
];

export const COMPACT_KEYS = ['shift', 'line_no', 'batches', 'total_planned',
  'actual_output', 'left_to_make', 'available_made', 'dispatched', 'rm_status',
  'required_date', 'instructions', 'remarks', 'actions'];

export const SHIFTS = [
  { v: 'day', l: 'Day' },
  { v: 'night', l: 'Night' },
  { v: 'day_night', l: 'Day + Night' },
];

export const PRIORITIES = [
  { v: 'critical', l: 'Critical' },
  { v: 'high', l: 'High' },
  { v: 'normal', l: 'Normal' },
  { v: 'low', l: 'Low' },
];

export const PERIODS = [
  { v: 'rolling7', l: 'Next 7 days' },
  { v: 'this_week', l: 'This week' },
  { v: 'next_week', l: 'Next week' },
  { v: 'this_month', l: 'This month' },
  { v: 'next_30', l: 'Next 30 days' },
  { v: 'last_month', l: 'Last month' },
  { v: 'custom', l: 'Custom…' },
];
